var utils = {
    isiOS: function () {
        if (utils.isNode()) {
            return false;
        }
        return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
    isNode: function () {
        return typeof (window) === 'undefined';
    },
    randomKey: function () {
        return Math.random()
            .toString(16)
            .substr(2);
    },
    getQuery: function (name, search) {
        if (search === void 0) { search = window.location && window.location.search.substr(1); }
        var queries = {};
        search &&
            search.split('&').forEach(function (c) {
                if (c === '') {
                    return;
                }
                var _a = c.split('='), key = _a[0], _b = _a[1], value = _b === void 0 ? '' : _b;
                value = value.replace('+', '%20');
                queries[decodeURIComponent(key)] =
                    value === '' ? true : decodeURIComponent(value);
            });
        return name ? queries[name] : queries;
    },
    flatten: function (arr) {
        return arr.reduce(function (a, b) { return a.concat(Array.isArray(b) ? utils.flatten(b) : b); }, []);
    }
};

/**
 * sample rewrite intl funciton, and use it to get locale strings in feoffline page;
 * this can not use in ssr page
 * if u want to use this in ssr page, u should enhance this function and replace the intl in node with this function;
 */
var Intl = /** @class */ (function () {
    function Intl() {
        this._locale = 'en';
        this._msg = {};
    }
    Intl.prototype.init = function (config) {
        var currentLocale = config.currentLocale, locales = config.locales;
        this._locale = currentLocale;
        this._msg = locales;
    };
    Intl.prototype.getMessages = function (key) {
        var messages = this._msg[this._locale || 'en'] || {};
        var _value = messages[key];
        if (!_value) {
            console.warn(key + " is not exist");
            return '';
        }
        return _value;
    };
    Intl.prototype.get = function (key) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        var _value = this.getMessages(key);
        if (_value && rest && Array.isArray(rest) && rest.length > 0) {
            // flatten the rest array
            var _rest_1 = utils.flatten(rest);
            _value = _value.replace(/{(\d+)}/gi, function ($0, $1) {
                return _rest_1[$1] || '';
            });
        }
        return _value;
    };
    Intl.prototype.format = function (msg, param) {
        if (!param) {
            return msg;
        }
        // use ['str1', 'str2'] to replace '%s', '%s' or '%d', '%d'
        if (Array.isArray(param)) {
            var replaceReg = /%(s|d)/gi;
            if (param.length === 1) {
                msg = msg.replace(replaceReg, param[0].toString());
            }
            else if (param.length > 1) {
                var idx_1 = 0;
                msg = msg.replace(replaceReg, function () {
                    return param[idx_1++].toString();
                });
            }
        }
        else {
            // use { name: 'Bob', age: 18 } to replace 'MyName: {name}, MyAge: {age}'
            if (typeof param !== 'object') {
                console.warn('intl.format\'s param should be array or object');
                return msg;
            }
            msg = msg.replace(/{(\w+)}/gi, function ($0, $1) {
                return (param[$1] || $0).toString();
            });
        }
        return msg;
    };
    return Intl;
}());
var intl = new Intl();

export default intl;
export { Intl };
